import styled from 'styled-components'

import { style } from 'theme'

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export const FormItem = styled.div`
  width: 100%;
  flex-basis: 100%;
  padding-bottom: 20px;
  @media screen and (min-width: ${style(theme => theme.breakpoints.md)}px) {
    flex-basis: 50%;
  }
`

export const ValidatorConatiner = styled.div`
  padding-top: 30px;
`
